/* eslint-disable no-restricted-imports*/
import React from 'react';
import cn from 'classnames';
import { ButtonProps as MuiButtonProps, Button as MUIButton, LinearProgress } from '@mui/material';
import { Corner } from '../..';
import { createSx } from '../../utils';

const sx = createSx({
  loader: {
    position: 'absolute',
    bottom: 0,
    width: '100%'
  },
});

export interface ButtonProps extends MuiButtonProps {
  uppercase?: boolean;
  underline?: boolean;
  active?: boolean;
  testID?: string;
  loading?: boolean;
  corner?: Corner;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({
  uppercase,
  underline,
  active,
  testID,
  loading,
  className,
  corner = 'round',
  children,
  ...props
}, ref) => {

  return (
    <MUIButton
      ref={ref}
      className={cn(className, `MuiButton-corner-${corner}`, { uppercase, underline, active, })}
      data-test-id={testID}
      {...props}
    >
      {children}
      {loading && <LinearProgress
        sx={sx.loader}
        color={props.color}
      />}
    </MUIButton>
  );
});

export default Button;